export default __webpack_public_path__ + "static/landscape-morning-50c77f2c6544f9c36ecf3b0d5d3b8e54.jpg";